<template>
<div class="gf-field-compound">
  <slot />
</div>
</template>

<script>
export default {

}
</script>
